import { useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'
import { Head } from '#/components/head'


export default function AppearanceError() {
  const { t } = useTranslation([ 'settings' ])
  const error = useRouteError()

  return (
    <div className="w-full">

      <Head title={t('appearance.page_title')} />

      <ErrorBoundary error={error} />

    </div>
  )
}
